import React from "react";

interface CustomCheckboxProps {
  checked: boolean;
  label: string;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}

const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  label,
  disabled,
  onChange,
}) => {
  return (
    <div
      className={`flex flex-row items-start gap-2 ${
        disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
      }`}
      onClick={() => {
        if (!disabled) {
          onChange(!checked);
        }
      }}
    >
      <span
        className={`w-4 h-4 border-2 rounded-sm flex items-center justify-center  
        ${
          checked ? "bg-[#F5CB2B] border-[#B3B3B3]" : "bg-white border-gray-400"
        } 
        ${!checked ? "text-transparent " : "text-white"} align-middle`}
      >
        {checked && (
          <svg
            className="w-3 h-3"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            color="#2B0C1A"
          >
            <path
              fillRule="evenodd"
              d="M16.293 5.293a1 1 0 011.414 1.414l-9 9a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L8 12.586l7.293-7.293z"
              clipRule="evenodd"
            />
          </svg>
        )}
      </span>
      <label className="text-sm font-medium leading-none flex-1">{label}</label>
    </div>
  );
};

export default CustomCheckbox;
